import { render, staticRenderFns } from "./TermsFooter.vue?vue&type=template&id=e15bd14a&scoped=true&"
var script = {}
import style0 from "./TermsFooter.vue?vue&type=style&index=0&id=e15bd14a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e15bd14a",
  null
  
)

export default component.exports